import { primaryColor } from "@/theme";
import { Icon } from "@mui/material";
import { useContext } from "react";
import { ListItemButtonSelectedContext } from "./ListItemButtonSelected";
import { DrawerContext } from "./DrawerContext";

interface SidebarIconProps {
  component: React.ElementType;
  color?: string;
  selectedColor?: string;
}

const SidebarIcon = ({ component, color, selectedColor = 'white' }: SidebarIconProps) => {
  const selectedItemContext = useContext(ListItemButtonSelectedContext);
  const isInDrawer = useContext(DrawerContext);

  const defaultColor = isInDrawer ? 'white' : primaryColor;
  const finalColor = color ?? defaultColor;

  return (
    <Icon component={component} sx={{ color: selectedItemContext ? selectedColor : finalColor }} />
  );
};

export default SidebarIcon;